function getFilteredSeries(series) {
  var _series$filter$length;

  // Only include solid lines (or non-lines) in the
  // count when grabbing the series color.
  return (_series$filter$length = series.filter(item => {
    if (item.isComparison !== true) {
      return true;
    }
  }).length) !== null && _series$filter$length !== void 0 ? _series$filter$length : 0;
}

export { getFilteredSeries };
